<template>
	<VCard
		flat
		:min-height="minHeightCard"
	>
		<div>
			<VCardTitle class="text-h5 font-weight-bold primary--text text-center">
				{{ title }}
			</VCardTitle>
			<VCardText class="primary--text text-lg-body-1">
				{{ content }}
			</VCardText>
		</div>
		<VCardActions class="pa-4">
			<VBtn
				:to="userType"
				large
				class="primary pa-4"
			>
				{{ $t('common.select') }}
				<VIcon
					size="20px"
					class="ml-2"
				>
					{{ arrowRight }}
				</VIcon>
			</VBtn>
		</VCardActions>
	</VCard>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { mdiArrowRight } from '@mdi/js';

	const Props = Vue.extend({
		props: {
			title: {
				type: String,
				required: true
			},
			content: {
				type: String,
				required: true
			},
			userType: {
				type: String,
				required: true
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component
	export default class UserCard extends MixinsDeclaration {
		arrowRight = mdiArrowRight;
		minHeighCard = 283;

		get minHeightCard(): number {
			return this.isSmAndDown ? 0 : this.minHeighCard;
		}

		get isSmAndDown(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}
	}
</script>

<style scoped>
.v-card {
	background-color: #E7ECF5;
	border: 1px solid #CED9EB;
	box-shadow: 0 0 5px 0 #0000000D;
	padding: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
</style>
